'use strict';

const table = require('./base-table.json'); // map for codecConstant -> code


const constants = {};

for (const [name, code] of Object.entries(table)) {
  constants[name.toUpperCase().replace(/-/g, '_')] = code;
}

module.exports = Object.freeze(constants);